import React from "react"

import {
	Box,
	Grid,
	IconButton,
	Stack,
	Tooltip,
	Typography,
} from "@mui/material"

import { Trans } from "@lingui/macro"

import Icon from "@mdi/react"
import {
	mdiAccountOutline,
	mdiTrashCanOutline,
} from "@mdi/js"

import {
	Workflow,
	WorkflowUtils,
	WorkflowStatus,
} from "models"

export interface WorkflowComponentDetailProps {
	data: Workflow
	openAssignDialog: (workflow: Workflow) => void
	openDeleteDialog: (workflow: Workflow) => void
}
export interface WorkflowComponentDetailState {
	default: boolean
}
export class WorkflowComponentPreview extends React.Component<WorkflowComponentDetailProps, WorkflowComponentDetailState> {
	private assignButton = (event: React.MouseEvent) => {
		event.stopPropagation()
		this.props.openAssignDialog(this.props.data)
	}

	private deleteButton = (event: React.MouseEvent) => {
		event.stopPropagation()
		this.props.openDeleteDialog(this.props.data)
	}

	render() {
		const data: Workflow = this.props.data

		return (
			<Grid container spacing={2} alignItems="center" p={0.5}>
				<Grid item xs="auto">
					<Box
						component={Icon}
						path={WorkflowUtils.renderIcon(data.objectType)}
						size="35px"
						sx={{
							color: "primary.contrastText",
							backgroundColor: data.status === WorkflowStatus.DONE ? "#0d6e00" : "primary.main",
							padding: "5px",
							mt: 2,
							borderRadius: "100%",
						}}>
					</Box>
				</Grid>
				<Grid item xs>
					<Stack direction="column">
						<Typography sx={{ fontSize: 20, fontWeight: "medium" }} color="primary">
							{data.name}
						</Typography>
						{data.executor &&
							<Typography sx={{ fontSize: 10, fontWeight: '600' }}>
								<Trans id={"workflow.assignedTo"}>
									Assegnato a &nbsp;
									{(data.executor.accountDetails && data.executor.accountDetails.firstName && data.executor.accountDetails.lastName) ?
										<span>{data.executor.accountDetails.firstName} {data.executor.accountDetails.lastName}</span> :
										<span>{data.executor.username}</span>
									}
								</Trans>
							</Typography>
						}
						<Typography sx={{ fontSize: 8 }}>
							{data.description}
						</Typography>
					</Stack>
				</Grid>
				<Grid item xs="auto">
					<Stack direction="row" spacing={1.5} sx={{ display: "block", }}>
						{data.status !== WorkflowStatus.DONE && <Tooltip title="Assegna" placement="top" arrow>
							<IconButton
								sx={{
									p: 0,
									color: 'grey',
									backgroundColor: "transparent",
									":hover": {
										color: "secondary.main"
									}
								}}
								aria-label="assign"
								onClick={this.assignButton}
								disableFocusRipple
								disableRipple>
								<Icon path={mdiAccountOutline} size={1.25} />
							</IconButton>
						</Tooltip>}
						<Tooltip title="Elimina" placement="top" arrow>
							<IconButton
								sx={{
									p: 0,
									color: 'grey',
									backgroundColor: "transparent",
									":hover": {
										color: "secondary.main"
									}
								}}
								aria-label="delete"
								onClick={this.deleteButton}
								disableFocusRipple
								disableRipple>
								<Icon path={mdiTrashCanOutline} size={1.25} />
							</IconButton>
						</Tooltip>
					</Stack>
				</Grid>
			</Grid>
		)
	}
}
